import { ReactNode } from 'react'
import { create } from 'zustand'

export type DialogOptions = {
  layout?: 'default' | 'content-only' | 'custom'
  title?: string
  description?: string
  size?: 'max-w-sm' | 'max-w-md' | 'max-w-lg' | 'max-w-2xl' | 'max-w-4xl' | 'max-w-6xl' | 'max-w-7xl' | 'max-w-fit'
  hideCloseButton?: boolean
}

export type DialogStore = DialogOptions & {
  content?: ReactNode
  assetSrc?: string
  show: boolean
  setShow: (show: boolean) => void
  update: (options: Partial<DialogStore>) => void
}

export const useDialogStore = create<DialogStore>((set) => ({
  title: '',
  description: '',
  layout: 'default',
  content: null,
  hideCloseButton: false,
  show: false,
  size: 'max-w-2xl',
  setShow: (show: boolean) => set({ show }),
  update: (options: Partial<DialogStore>) => set(options),
}))
